import { createFileRoute, Outlet } from "@tanstack/react-router";
import { LayoutDashboard, Receipt, Heart, UserCog, Search, Sparkles, Repeat } from "lucide-react";
import { DashboardShell, type NavItem } from "@/components/dashboard-shell";

const items: NavItem[] = [
  { to: "/donor", label: "Dashboard", icon: LayoutDashboard },
  { to: "/donor/discover", label: "Discover", icon: Search },
  { to: "/donor/history", label: "Donation History", icon: Receipt },
  { to: "/donor/recurring", label: "Monthly Giving", icon: Repeat },
  { to: "/donor/impact", label: "Impact Tracker", icon: Sparkles },
  { to: "/donor/favorites", label: "Favourites", icon: Heart },
  { to: "/donor/profile", label: "Profile", icon: UserCog },
];

export const Route = createFileRoute("/donor")({
  head: () => ({ meta: [{ title: "Donor Dashboard — Animal Seva" }] }),
  component: () => (
    <DashboardShell
      role="Rahul Shah"
      orgName="Donor · Ahmedabad"
      color="var(--saffron-deep)"
      items={items}
    >
      <Outlet />
    </DashboardShell>
  ),
});
